import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=74c7b4ee&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=74c7b4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7b4ee",
  null
  
)

/* custom blocks */
import block0 from "@/locales/label.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FBadge%2FBadge.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports